import { createContext } from 'react';

/** Author-owned preview sources stay in memory and never enter wire DTOs or shared media caches. */
export interface LocalMediaSource { bytes: Blob | null; mediaId: string | null }
export const LocalMediaContext = createContext<ReadonlyMap<string, LocalMediaSource>>(new Map());
